import styled from 'styled-components';

export const Input = styled.input`
  height: 36px;
  padding: 10px;
  border: 1px solid var(--color-dark-gray);
  border-radius: 4px;
  background-color: var(--color-oxford-blue);
  color: var(--color-light-gray);
  font-size: var(--font-size-600);

  &::placeholder {
    font-size: var(--font-size-600) !important;
  }
`;
